import { render, staticRenderFns } from "./employeesDeptDialog.vue?vue&type=template&id=2df0369a"
import script from "./employeesDeptDialog.vue?vue&type=script&lang=js"
export * from "./employeesDeptDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports